var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CertificateTemplate',{attrs:{"type_id":_vm.type_id,"title":_vm.title,"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }